// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filteredCount_root__1t9Hb {\n  display: flex;\n  margin-right: 20px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: #464646; }\n  .filteredCount_root__1t9Hb .filteredCount_title__3iPgi {\n    color: #333333;\n    text-align: center; }\n  .filteredCount_root__1t9Hb .filteredCount_count__3d3Sy {\n    color: #333333;\n    font-weight: 600;\n    font-size: 14px;\n    margin-left: 4px; }\n", ""]);
// Exports
exports.locals = {
	"root": "filteredCount_root__1t9Hb",
	"title": "filteredCount_title__3iPgi",
	"count": "filteredCount_count__3d3Sy"
};
module.exports = exports;
